import React, { useContext, useRef, useEffect } from 'react';
import ClientsContext from '../../context/clients/clientsContext';
const ClientFilter = () => {
  const clientsContext = useContext(ClientsContext);
  const { filterClients, clearFilter, filtered } = clientsContext;
  const text = useRef('');

  useEffect(() => {
    if (filtered === null) {
      text.current.value = '';
    }
  });

  const onChange = e => {
    if (text.current.value !== '') {
      filterClients(e.target.value);
    } else {
      clearFilter();
    }
  };

  return (
    <form>
      <input
        ref={text}
        type='text'
        placeholder='Filter Clients'
        onChange={onChange}
      />
    </form>
  );
};

export default ClientFilter;
